import Navbar from "../../components/navbar/index.jsx";
import ListaCertificado from "../../components/ListaCertificado/listacertificado.jsx";

function Certificado(){

    return  <div>
          <Navbar/>
            <div className="container-fluid titulo" >
                 <h7>Certificados e documentos diversos</h7>      
                 <ListaCertificado/>
            </div>
    </div>

}
export default Certificado;
